/**
 * <ReferralStatTile> — un compteur du tableau de parrainage (molecule).
 *
 * Le chiffre d'abord, ce qu'il compte dessous. Le legacy écrit « Clics sur le lien : 12 » en ligne,
 * au fond du repli des conditions ; sur une page, le chiffre est l'information, pas son étiquette.
 *
 * La tuile ne porte ni surface ni largeur : la carte qui la reçoit décide de la grille, pour qu'un
 * même compteur tienne dans une colonne de téléphone comme dans une rangée de quatre.
 */
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"

export type ReferralStatTileProps = {
    /** Déjà un libellé — « 12 », « 50 € ». */
    value: string
    label: string
    testID?: string
}

export function ReferralStatTile(props: ReferralStatTileProps) {
    const { value, label, testID } = props

    return (
        <Stack gap="0" testID={testID}>
            <Text size="text-2xl" weight="bold" color="primary">
                {value}
            </Text>
            <Text size="text-sm" color="text-muted">
                {label}
            </Text>
        </Stack>
    )
}
